import {
  FETCH_SERVICE_USAGE_FAILURE,
  FETCH_SERVICE_USAGE_REQUEST,
  FETCH_SERVICE_USAGE_SUCCESS,
} from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
  siteId: null,
  dateRange: null,
  receivedAt: null,
};

const serviceUsageReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_SERVICE_USAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        siteId: action.meta?.siteId,
        dateRange: action.meta?.dateRange,
      };
    case FETCH_SERVICE_USAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
        siteId: action.meta?.siteId,
        dateRange: action.meta?.dateRange,
        receivedAt: action.meta?.receivedAt || Date.now(),
      };
    case FETCH_SERVICE_USAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        siteId: action.meta?.siteId,
        dateRange: action.meta?.dateRange,
      };
    default:
      return state;
  }
};

export default serviceUsageReducer;
